import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "slogan" }
const _hoisted_6 = {
  key: 0,
  class: "stack"
}
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_group = _resolveComponent("link-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
    style: _normalizeStyle(_ctx.styleObject)
  }, [
    _createVNode(_Transition, {
      name: "detail",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "detail",
              onClick: _cache[0] || (_cache[0] = e => e.stopPropagation())
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: `images/${_ctx.project.slug}-icon.png`
                  }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.project.title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.project.slogan), 1),
                  (_ctx.project.stack)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.stack, (tech, i) => {
                          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(tech), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.project.screenshot)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass({screenshot: true, shadow: _ctx.project.screenshotShadow ?? true}),
                    src: `images/${_ctx.project.slug}-screenshot.png`
                  }, null, 10, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.project.links)
                ? (_openBlock(), _createBlock(_component_link_group, {
                    key: 1,
                    links: _ctx.project.links,
                    themeColor: _ctx.project.themeColor,
                    textColor: _ctx.project.textColor
                  }, null, 8, ["links", "themeColor", "textColor"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 4))
}